// extracted by mini-css-extract-plugin
export default {"component":"SmsBuyButton_component__Y9nVC","button":"SmsBuyButton_button__ktIbQ","smsText":"SmsBuyButton_smsText__lXpBn"};